/**
 * Public App Store listing — override via `VITE_APP_STORE_URL` if needed.
 *
 * Use the ID-only path (`/app/id{numericId}`). The marketing slug `id-go-back`
 * starts with `id-`, and iOS App Store URL handling treats `/app/id*` as an
 * item ID, which produces "Cannot Connect to iTunes Store" on iPhone/iPad.
 */
export const APP_STORE_URL =
  (import.meta.env.VITE_APP_STORE_URL as string | undefined)?.trim() ||
  'https://apps.apple.com/app/id6761342920';

/** Public Play Store listing — override via `VITE_PLAY_STORE_URL` if needed. */
export const PLAY_STORE_URL =
  (import.meta.env.VITE_PLAY_STORE_URL as string | undefined)?.trim() ||
  'https://play.google.com/store/apps/details?id=com.idgoback.app';
